//Making my route optmized, time is reduced
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import Layouts from "../../layouts/layouts";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import "leaflet-routing-machine";
import RoutingMachine from "./RoutingMachine";
import * as turf from "@turf/turf";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const routeColors = ["#FF0000", "#0000FF", "#008000", "#800080", "#FFA500"];
// const startingPoint = [30.7076636, 76.6855201];

export default function MyMapComponentOrder() {
  const markerRef = useRef(null);
  const [orsPolylines, setOrsPolylines] = useState({}); // { index: routePolyline }
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [startingPoint, setStartingPoint] = useState(null); // initially null
  const [startingPointSet, setStartingPointSet] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { orderData } = location.state || {};
  const [selectedDate, setSelectedDate] = useState(
    orderData?.delivery_date || ""
  );
  const [selectedClient, setSelectedClient] = useState(
    orderData?.client_id || ""
  );
  const { id } = useParams();
  const [selectedVehicles, setSelectedVehicles] = useState({});
  const [selectedDrivers, setSelectedDrivers] = useState({});
  const [selectedDAs, setSelectedDAs] = useState({});

  const [vehicleCount, setVehicleCount] = useState(1);
  const [routes, setRoutes] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [users, setUsers] = useState([]);
  const [clients, setClients] = useState([]);
  const [routeAssignments, setRouteAssignments] = useState([]);
  const selectedClientObj = clients.find(
    (client) => client._id === selectedClient
  );
  const existingOrderData = location.state?.orderData || {}; // Retrieve previous order data

  const [formData, setFormData] = useState({
    vehicle_id: "",
    daUserId: "",
    driver_id: "",
    hub_id: "",
    client_id: "",
    delivery_date: "",
  });

  const ORS_API_KEY =
    "5b3ce3597851110001cf6248350951574cfd4d67bdf15c2608a63e91";

  useEffect(() => {}, [routes]);

  const ORSRouting = ({
    waypoints = [],
    color = "blue",
    routeIndex,
    onRouteFetched,
  }) => {
    const [routeCoords, setRouteCoords] = useState([]);
    const map = useMap();

    useEffect(() => {
      const fetchORSRoute = async () => {
        if (waypoints.length < 2) return;

        try {
          const coords = waypoints.map((wp) =>
            Array.isArray(wp) ? [wp[1], wp[0]] : [wp.lng, wp.lat]
          );

          const response = await axios.post(
            "https://api.openrouteservice.org/v2/directions/driving-car/geojson",
            { coordinates: coords },
            {
              headers: {
                Authorization: ORS_API_KEY,
                "Content-Type": "application/json",
              },
            }
          );

          const geometry = response.data.features[0].geometry;
          const leafletCoords = geometry.coordinates.map((coord) => [
            coord[1],
            coord[0],
          ]);

          setRouteCoords(leafletCoords);
          onRouteFetched(routeIndex, leafletCoords); // Pass to parent
          map.fitBounds(leafletCoords);
        } catch (error) {
          console.error("ORS route fetch error:", error);
        }
      };

      fetchORSRoute();
    }, [waypoints]);

    return routeCoords.length ? (
      <Polyline positions={routeCoords} color={color} weight={4} />
    ) : null;
  };
  const handleRouteFetched = (index, coords) => {
    setOrsPolylines((prev) => ({ ...prev, [index]: coords }));
  };
  useEffect(() => {
    if (!orderData?.delivery_information) {
      return;
    }

    const optimizedRoutes =
      clusterOrdersByArea(orderData.delivery_information, vehicleCount) || [];

    console.log("Optimized Routes:", optimizedRoutes);
    setRoutes(optimizedRoutes);

    // const orderMap = new Map();
    // orderData.delivery_information.forEach((order) => {
    //   const key = `${order.delivery_address.lat},${order.delivery_address.lng}`;
    //   orderMap.set(key, order);
    // });
    const orderMap = new Map();

    orderData.delivery_information.forEach((order) => {
      const key = `${order.delivery_address.lat},${order.delivery_address.lng}`;
      if (!orderMap.has(key)) {
        orderMap.set(key, []);
      }
      orderMap.get(key).push(order); // store all orders at that lat/lng
    });
    let orderCounters = {};

    const formattedRoutes = optimizedRoutes.map((route, index) => ({
      hub_id: orderData.hub_id || formData.hub_id || null,
      client_id: orderData.client_id || formData.client_id || null,
      driver_id: null,
      daUserId: null,
      vehicle_id: null,
      delivery_date: orderData.delivery_date || formData.delivery_date || "N/A",
      // orders: route
      //   // .slice(1)
      //   .map(([lat, lng], index) => {
      //     const key = `${lat},${lng}`;
      //     const order = orderMap.get(key);

      //     return order
      //       ? {
      //           sequence: index + 1, // 💥 This resets per route
      //           total_amount: order.total_amount || 0,
      //           delivery_address: {
      //             lat: order.delivery_address.lat,
      //             lng: order.delivery_address.lng,
      //             address: order.delivery_address.address || "N/A",
      //           },
      //           customer_detail: {
      //             customer_name:
      //               order.customer_detail.customer_name || "Unknown",
      //             customer_phone: order.customer_detail.customer_phone || "N/A",
      //           },
      //         }
      //       : null;
      //   })

      //   .filter((order) => order !== null),
      orders: route
        .map(([lat, lng], idx) => {
          const key = `${lat},${lng}`;
          const ordersAtLocation = orderMap.get(key) || [];

          if (!orderCounters[key]) orderCounters[key] = 0;
          const order = ordersAtLocation[orderCounters[key]];
          orderCounters[key]++;

          return order
            ? {
                sequence: idx + 1,
                total_amount: order.total_amount || 0,
                delivery_address: {
                  lat: order.delivery_address.lat,
                  lng: order.delivery_address.lng,
                  address: order.delivery_address.address || "N/A",
                },
                customer_detail: {
                  customer_name:
                    order.customer_detail.customer_name || "Unknown",
                  customer_phone: order.customer_detail.customer_phone || "N/A",
                },
              }
            : null;
        })
        .filter(Boolean),
    }));

    setRouteAssignments(formattedRoutes);
  }, [orderData, vehicleCount]); // 👈 REMOVE selectedVehicles, selectedDrivers, selectedDAs

  useEffect(() => {
    console.log("Updated Route Assignments:", routeAssignments);
  }, [routeAssignments]);

  useEffect(() => {
    if (startingPointSet) {
      return;
    }

    const fetchHubDetails = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole");

        if (!token || !userRole) {
          console.error("⛔ Token or role missing");
          return;
        }

        let apiUrl;
        if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/hubs`;
        } else if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/hubs`;
        } else {
          return;
        }

        const response = await axios.get(apiUrl, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const hubs = response.data?.hubs || [];
        const selectedHubId = orderData?.hub_id || formData?.hub_id;

        if (!selectedHubId) {
          return;
        }

        const selectedHub = hubs.find((hub) => hub._id === selectedHubId);

        if (
          selectedHub?.coordinates?.latitude &&
          selectedHub?.coordinates?.longitude
        ) {
          const hubPoint = [
            selectedHub.coordinates.latitude,
            selectedHub.coordinates.longitude,
          ];
          setStartingPoint(hubPoint);
          setStartingPointSet(true);
        } else {
          console.warn("⚠️ Coordinates missing for selected hub:", selectedHub);
        }
      } catch (error) {
        console.error("❌ Error fetching hub details:", error);
      }
    };

    fetchHubDetails();
  }, [orderData?.hub_id, formData?.hub_id, startingPointSet]);

  const handleRouteSelection = (routeIndex, field, value) => {
    setRouteAssignments((prevRoutes) =>
      prevRoutes.map((route, index) =>
        index === routeIndex ? { ...route, [field]: value } : route
      )
    );

    if (field === "vehicle_id") {
      setSelectedVehicles((prev) => ({ ...prev, [routeIndex]: value }));
    } else if (field === "driver_id") {
      setSelectedDrivers((prev) => ({ ...prev, [routeIndex]: value }));
    } else if (field === "daUserId") {
      setSelectedDAs((prev) => ({ ...prev, [routeIndex]: value }));
    }
  };
  const buildRouteFromHub = (deliveryInfo, hubCoords) => {
    if (!Array.isArray(deliveryInfo)) {
      return [hubCoords]; // fallback
    }

    const deliveryPoints = deliveryInfo
      .map((order) => {
        const lat = order.delivery_address?.lat;
        const lng = order.delivery_address?.lng;
        if (lat && lng) return [lat, lng];
        return null;
      })
      .filter(Boolean); // remove nulls

    return [hubCoords, ...deliveryPoints]; // start at hub
  };

  useEffect(() => {
    if (!startingPoint || !orderData?.delivery_information?.length) return;

    // Extract coordinates from delivery information
    const deliveryCoords = orderData.delivery_information.map((order) => [
      order.delivery_address.lat,
      order.delivery_address.lng,
    ]);

    // Optimize route (your existing logic)
    const optimizedRoute = optimizeRoute(deliveryCoords);

    // Prepend the starting point (hub) to the route
    const fullRoute = [startingPoint, ...optimizedRoute];

    // Set as one single route in an array (to support multiple later)
    // setRoutes([fullRoute]);
  }, [startingPoint, orderData]);

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole"); // Get user role from localStorage

        if (!token || !userRole) {
          console.error("No token or user role found");
          return;
        }

        // Determine API endpoint based on userRole
        let apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`; // Default for superadmin

        if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/vehicles`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/vehicles`;
        }

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setVehicles(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    };

    fetchVehicles();
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole"); // Get user role

        if (!token) {
          console.error("No token found");
          return;
        }

        // Determine API URL based on role
        const apiUrl =
          userRole === "superadmin"
            ? `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`
            : `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/users`;

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (Array.isArray(response.data.users)) {
          setUsers(response.data.users);
        } else {
          console.error("Unexpected data format from API", response.data);
          setUsers([]);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/clients`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClients(response.data.clients);
      } catch (error) {
        setClients([]);
      }
    };
    fetchClients();
  }, []);

  const onSubmitHandler = async (event) => {
    setIsSubmitting(true);
    event.preventDefault();

    // Show confirmation popup before submitting
    const isConfirmed = window.confirm(
      "Please verify the data again. Once created, you can't change it. Do you want to continue?"
    );

    if (!isConfirmed) {
      return; // Prevent API call if user clicks "Cancel"
    }

    const token = localStorage.getItem("token");
    const userRole = localStorage.getItem("userRole"); // Get user role

    if (!token) {
      console.error("No token found");
      return;
    }
    if (routeAssignments.length === 0) {
      alert("No routes assigned! Please add routes before submitting.");
      return;
    }

    let routesData = {};
    routeAssignments.forEach((route, index) => {
      routesData[`Route${index + 1}`] = {
        hubId: route.hub_id,
        clientId: route.client_id,
        driverId: route.driver_id,
        daUserId: route.daUserId,
        vehicleId: route.vehicle_id,
        deliveryDate: route.delivery_date,
        orders: route.orders,
      };
    });
    let apiUrl;
    if (userRole === "superadmin") {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/order-routes/super-admin/create-routes`;
    } else if (userRole === "admin") {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/order-routes/admin/create-routes`;
    } else if (userRole === "clientmanager") {
      apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/order-routes/client-manager/create-routes`;
    } else {
      console.error("Unauthorized role:", userRole);
      return;
    }

    try {
      const response = await axios.post(apiUrl, routesData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 201) {
        navigate("/clientorders");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error.response ? error.response.data : error);
    }
    setTimeout(() => {
      setIsSubmitting(false);
    }, 30000);
  };

  const generateRoutes = (coordinates) => {

    if (coordinates.length === 0) return;

    const clusters = performKMeansClustering(coordinates, vehicleCount);

    const optimizedRoutes = clusters.map((cluster, i) => {
      const route = [startingPoint, ...cluster];
      return optimizeRoute(route);
    });

    setRoutes(optimizedRoutes);
  };

  const performKMeansClustering = (coordinates, k) => {

    if (k > coordinates.length) k = coordinates.length;

    const centroids = [startingPoint, ...coordinates.slice(0, k - 1)];

    const clusters = Array.from({ length: k }, () => []);

    coordinates.forEach((point) => {
      const distances = centroids.map((center) =>
        Math.hypot(point[0] - center[0], point[1] - center[1])
      );
      const nearest = distances.indexOf(Math.min(...distances));
      clusters[nearest].push(point);
    });

    return clusters;
  };
  useEffect(() => {
  }, [startingPoint]);
  const clusterOrdersByArea = (orders, vehicleCount) => {
    if (!orders || orders.length === 0) return [];

    const points = orders.map((order) =>
      turf.point([order.delivery_address.lng, order.delivery_address.lat])
    );
    const featureCollection = turf.featureCollection(points);

    const clustered = turf.clustersKmeans(featureCollection, {
      numberOfClusters: vehicleCount,
    });

    const clusters = Array.from({ length: vehicleCount }, () => []);

    clustered.features.forEach((feature, index) => {
      const clusterId = feature.properties.cluster;
      const lat = feature.geometry.coordinates[1];
      const lng = feature.geometry.coordinates[0];
      clusters[clusterId].push([lat, lng]);
    });

    // Sort each cluster route (optional: apply TSP-style optimization)
    return clusters.map((cluster) =>
      optimizeRoute([startingPoint, ...cluster])
    );
  };
  // const clusterOrdersByArea = (orders, vehicleCount) => {
  //   if (!orders || orders.length === 0) return [];

  //   // Group orders by area (rough clustering)
  //   const areaClusters = {};
  //   orders.forEach((order) => {
  //     const { lat, lng } = order.delivery_address;
  //     const areaKey = `${lat.toFixed(2)},${lng.toFixed(2)}`;
  //     if (!areaClusters[areaKey]) {
  //       areaClusters[areaKey] = [];
  //     }
  //     areaClusters[areaKey].push([lat, lng]);
  //   });

  //   // Convert clusters to an array & distribute among vehicles
  //   let clusteredRoutes = Object.values(areaClusters);
  //   clusteredRoutes.sort((a, b) => b.length - a.length);

  //   const vehicleRoutes = Array.from({ length: vehicleCount }, () => []);
  //   clusteredRoutes.forEach((cluster, index) => {
  //     vehicleRoutes[index % vehicleCount].push(...cluster);
  //   });

  //   // Optimize each vehicle's route
  //   return vehicleRoutes.map((route) =>
  //     optimizeRoute([startingPoint, ...route])
  //   );
  // };

  // const optimizeRoute = (coordinates) => {
  //   if (!coordinates || coordinates.length === 0) return [];

  //   const visited = new Set();
  //   const route = [coordinates[0]];
  //   let current = 0;

  //   while (visited.size < coordinates.length) {
  //     visited.add(current);
  //     let nearest = null;
  //     let minDistance = Infinity;

  //     coordinates.forEach((point, index) => {
  //       if (!visited.has(index)) {
  //         const distance = Math.hypot(
  //           coordinates[current][0] - point[0],
  //           coordinates[current][1] - point[1]
  //         );
  //         if (distance < minDistance) {
  //           minDistance = distance;
  //           nearest = index;
  //         }
  //       }
  //     });

  //     if (nearest !== null) {
  //       current = nearest;
  //       route.push(coordinates[current]);
  //     } else break;
  //   }
  //   return route;
  // };

  const optimizeRoute = (coordinates) => {
    if (!Array.isArray(coordinates) || coordinates.length === 0) return [];

    // Filter out any invalid coordinate points
    const validCoordinates = coordinates.filter(
      (point) =>
        Array.isArray(point) &&
        point.length === 2 &&
        typeof point[0] === "number" &&
        typeof point[1] === "number"
    );

    if (validCoordinates.length === 0) {
      return [];
    }

    const visited = new Set();
    const route = [validCoordinates[0]];
    let current = 0;

    while (visited.size < validCoordinates.length) {
      visited.add(current);
      let nearest = null;
      let minDistance = Infinity;

      validCoordinates.forEach((point, index) => {
        if (!visited.has(index)) {
          const distance = Math.hypot(
            validCoordinates[current][0] - point[0],
            validCoordinates[current][1] - point[1]
          );
          if (distance < minDistance) {
            minDistance = distance;
            nearest = index;
          }
        }
      });

      if (nearest !== null) {
        current = nearest;
        route.push(validCoordinates[current]);
      } else {
        break;
      }
    }

    return route;
  };

  useEffect(() => {
    if (orderData?.delivery_information) {
      const optimizedRoutes = clusterOrdersByArea(
        orderData.delivery_information,
        vehicleCount
      );
      setRoutes(optimizedRoutes);
    }
  }, [orderData, vehicleCount]);

  return (
    <>
      <Layouts />
      <div className="card-body">
        <div className="row justify-content-center">
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="me-3">
              <label>
                <b style={{ color: "red" }}> VEHICLE COUNT : </b>
                <input
                  type="number"
                  min="1"
                  value={vehicleCount}
                  onChange={(e) => setVehicleCount(Number(e.target.value))}
                  style={{ marginLeft: "10px" }}
                />
              </label>
            </div>
            <div className="me-3">
              <label>
                <b style={{ color: "red" }}> SELECT DATE : </b>
                <input
                  type="date"
                  value={selectedDate}
                  readOnly
                  style={{ marginLeft: "10px" }}
                />
              </label>
            </div>

            <div>
              <label>
                <b style={{ color: "red" }}> SELECT CLIENT : </b>
                <input
                  type="text"
                  value={
                    selectedClientObj ? selectedClientObj.name : "Not Found"
                  }
                  readOnly
                  style={{ marginLeft: "10px" }}
                />
              </label>
            </div>
          </div>
          <div className="d-flex justify-content-end mt-2">
            <button
              className="btn btn-secondary mb-3"
              onClick={() =>
                navigate("/create_clientorders", {
                  state: { orderData: existingOrderData },
                })
              }
            >
              Back
            </button>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="row">
          <div
            className="col-md-3 bg-light p-3"
            style={{ height: "86vh", overflowY: "auto" }}
          >
            <h3 className="mb-3">Route Details</h3>
            {routes.map((route, index) => {
              const vehicleColor = routeColors[index % routeColors.length];

              // Get already selected values
              const selectedVehicleIds = Object.values(selectedVehicles);
              const selectedDriverIds = Object.values(selectedDrivers);
              const selectedDAIds = Object.values(selectedDAs);
              const addressMap = new Map();
              orderData.delivery_information.forEach((order) => {
                const key = `${order.delivery_address.lat},${order.delivery_address.lng}`;
                addressMap.set(key, order.delivery_address.address);
              });
              return (
                <div
                  key={index}
                  className="p-3 mb-3 rounded shadow-sm"
                  style={{
                    border: `2px solid ${vehicleColor}`,
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                  }}
                >
                  <h6
                    className="p-2 text-center"
                    style={{
                      backgroundColor: vehicleColor,
                      color: "#fff",
                      borderRadius: "5px",
                    }}
                  >
                    Route {index + 1}
                  </h6>

                  <ul className="mt-2 ps-3">
                    {route
                      .filter((coord) => {
                        // Ensure startingPoint and coord are valid
                        if (
                          !Array.isArray(coord) ||
                          !Array.isArray(startingPoint) ||
                          coord.length < 2 ||
                          startingPoint.length < 2
                        ) {
                          return true; // keep the coord if we can't compare
                        }

                        return !(
                          coord[0] === startingPoint[0] &&
                          coord[1] === startingPoint[1]
                        );
                      })
                      .map((coord, i) => {
                        const key = `${coord[0]},${coord[1]}`;
                        const matchingAddress = addressMap.get(key);

                        return (
                          <li key={i} className="py-1">
                            <span
                              style={{
                                color: vehicleColor,
                                fontWeight: "bold",
                                marginRight: "5px",
                              }}
                            >
                              {i + 1}.
                            </span>
                            {matchingAddress ||
                              `Lat: ${coord[0]}, Lng: ${coord[1]}`}
                          </li>
                        );
                      })}
                  </ul>

                  <div className="mb-2">
                    <label className="form-label">Vehicle:</label>
                    <Select
                      options={vehicles
                        .filter(
                          (vehicle) => !selectedVehicleIds.includes(vehicle._id)
                        )
                        .map((vehicle) => ({
                          value: vehicle._id,
                          label: `${vehicle.numberplate}`,
                        }))}
                      onChange={(option) =>
                        handleRouteSelection(index, "vehicle_id", option.value)
                      }
                      classNamePrefix="select"
                    />
                  </div>

                  <div className="mb-2">
                    <label className="form-label">Driver:</label>
                    <Select
                      options={users
                        .filter(
                          (user) =>
                            user.id_generalStaffType?.name === "Driver" &&
                            !selectedDriverIds.includes(user._id)
                        )
                        .map((user) => ({
                          value: user._id,
                          label: `${user.name} (${user.phonenumber})`,
                        }))}
                      onChange={(option) =>
                        handleRouteSelection(index, "driver_id", option.value)
                      }
                      classNamePrefix="select"
                    />
                  </div>

                  <div className="mb-2">
                    <label className="form-label">DA:</label>
                    <Select
                      options={users
                        .filter(
                          (user) =>
                            user.id_generalStaffType?.name === "DA Label" &&
                            !selectedDAIds.includes(user._id)
                        )
                        .map((user) => ({
                          value: user._id,
                          label: `${user.name} (${user.phonenumber})`,
                        }))}
                      onChange={(option) =>
                        handleRouteSelection(index, "daUserId", option.value)
                      }
                      classNamePrefix="select"
                    />
                  </div>
                </div>
              );
            })}

            {/* Submit Button to Send All Routes */}
            {/* <button
              onClick={onSubmitHandler}
              className="btn btn-success w-100 mt-3"
            >
              Submit Routes
            </button> */}
            <button
              onClick={onSubmitHandler}
              className="btn btn-success w-100 mt-3"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit Routes"}
            </button>
          </div>
          <div className="col-md-9">
            {startingPoint ? (
              <MapContainer
                center={startingPoint}
                zoom={12}
                style={{ width: "100%", height: "86vh" }}
              >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                {routes.map((routeCoords, index) => {
                  const fullRoute = [startingPoint, ...routeCoords];
                  if (orsPolylines[index]) {
                    return (
                      <Polyline
                        key={index}
                        positions={orsPolylines[index]}
                        color={routeColors[index % routeColors.length]}
                        weight={4}
                      />
                    );
                  }
                  return (
                    <ORSRouting
                      key={index}
                      routeIndex={index}
                      waypoints={fullRoute}
                      color={routeColors[index % routeColors.length]}
                      onRouteFetched={handleRouteFetched}
                    />
                  );
                })}

                {startingPoint && (
                  <Marker
                    position={startingPoint}
                    icon={L.icon({
                      iconUrl: "/warehouse.png", // your custom warehouse icon
                      iconSize: [32, 32],
                      iconAnchor: [16, 32], // optional: center bottom
                    })}
                  >
                    <Popup>
                      <strong>Hub Starting Point</strong>
                    </Popup>
                  </Marker>
                )}

                {Array.isArray(orderData?.delivery_information) &&
                  orderData.delivery_information.map((order, i) => {
                    const lat = order.delivery_address?.lat;
                    const lng = order.delivery_address?.lng;
                    if (!lat || !lng) return null;

                    return (
                      <Marker key={i} position={[lat, lng]}>
                        <Popup>
                          <div>
                            <p>
                              <strong>Order {i + 1}</strong>
                            </p>
                            <p>
                              <strong>Address:</strong>{" "}
                              {order.delivery_address?.address || "Unknown"}
                            </p>
                          </div>
                        </Popup>
                      </Marker>
                    );
                  })}
              </MapContainer>
            ) : (
              <p>Loading map...</p> // or a spinner
            )}
          </div>
        </div>
      </div>
    </>
  );
}
